<template>
  <!-- start navigator -->
  <div class="container ps-lg-5 pe-lg-5 mt-1">
    <div class="row">
      <div class="
            col-12
            d-none d-lg-flex
            justify-content-between
            align-items-center
          ">
        <nav style="--bs-breadcrumb-divider: '>'" aria-label="breadcrumb">
          <ol class="breadcrumb DB-Heavent">
            <li class="breadcrumb-item">
              <router-link class="text-decoration-none router-link" to="/ProspectService">หน้าแรก</router-link>
            </li>
            <!-- <li class="breadcrumb-item router-link active" aria-current="page">
                ข้อมูลยื่นคำร้อง
              </li> -->
          </ol>
        </nav>
      </div>
    </div>
  </div>
  <!-- end navigator -->

  <div class="container-lg">
    <div class="row">
      <!-- Left Menu ps-0 pe-0 ps-lg-5 pe-lg-3 col-left-menu d-none d-lg-inline-block -->
      <div class="col-left-menu d-none d-lg-inline-block">
        <div class="left-menu">
          <ul class="d-flex d-lg-block">
            <Menu />
          </ul>
        </div>
      </div>
      <!-- Left Menu -->
      <!-- Mobile Menu -->
      <div class="d-block p-0">
        <div class="
              ps-0
              pe-0
              ps-lg-5
              pe-lg-3
              col-left-menu
              d-inline-block d-lg-none
            ">
          <div class="left-menu">
            <ul class="d-flex d-lg-block fw-normal">
              <li class="menu-item mian-menu opened">
                <div class="claim-list active">
                  <router-link to="/ProspectService"
                    class="blue-1 font-family text-decoration-none">ข้อมูลยื่นคำร้อง</router-link>
                  <div class="caret d-none d-lg-block"></div>
                </div>
              </li>
              <li class="menu-item mian-menu">
                <div class="claim-history">
                  <router-link to="/ProspectHistory"
                    class="white font-family text-decoration-none">ประวัติการแก้ไข</router-link>
                  <div class="caret d-none d-lg-block"></div>
                </div>
              </li>
            </ul>
          </div>
          <div class="left-menu">
            <div class="sub-menu text-left" id="opened-info-sub-menu" style="display: block">
              <ul class="nav d-flex align-items-center blue-1 p-3 ps-5 border-bottom">
                <li class="nav-item d-block">
                  <img src="@/assets/images/icon-profile.svg" />
                </li>
                <li class="nav-item d-block fw-normal font-family" style="font-size: 23px;">
                  {{ this.$store.state.UserName }}
                </li>
                <li class="nav-item d-block fw-normal font-family ps-4 text-end" style="font-size: 23px;">
                  <label class="font-family text-decoration-underline blue-1" style="cursor: pointer;"
                    @click="DownloadMenual()">คู่มือการใช้งานระบบ</label>
                </li>
              </ul>
              <MenuMobile />
            </div>
          </div>
        </div>
      </div>
      <!-- Mobile Menu -->
    </div>
  </div>

  <div v-if="this.Loading">
    <LoadingBs5></LoadingBs5>
  </div>
</template>

<script>
import MenuMobile from "@/components/prospectservice/MenuMobile.vue";
import Menu from "@/components/prospectservice/Menu.vue";

import LoadingBs5 from "@/components/frontend/LoadingBs5";
import http from "@/services/AuthService";
import Swal from 'sweetalert2/src/sweetalert2.js';

export default {
  name: "ProspectServiceView",
  components: {
    MenuMobile,
    Menu,
    LoadingBs5
  },
  data() {
    return {
      Loading: false
    };
  },
  async created() {
    this.CheckInActive();
  },
  mounted() {
    if (this.$store.state.USER_NAME == '') {
      this.$router.push('/');
    }
  },
  methods: {
    DownloadMenual() {
      this.Loading = true;
      let AuthorizeToken = localStorage.getItem("AuthorizeToken");

      http.get("AgencyERequest/GetFileManual", { headers: { Authorization: `Bearer ${AuthorizeToken}` } }).then((response) => {
        if (response.status == 200) {
          const linkSource = `data:${response.data.ContentType};base64,${response.data.FileData}`;
          const downloadLink = document.createElement('a');
          document.body.appendChild(downloadLink);

          downloadLink.href = linkSource;
          downloadLink.target = '_self';
          downloadLink.download = response.data.FileName;
          downloadLink.click();

          this.Loading = false;
        }
      }).catch((error) => { this.Loading = false; });
    },
    async CheckInActive() {
      let AuthorizeToken = localStorage.getItem("AuthorizeToken");
      this.Loading = true;
      await http.get("AgencyERequest/GetName", { headers: { Authorization: `Bearer ${AuthorizeToken}` } }).then((response) => {
        if (response.status == 200) {
          this.$store.state.UserName = response.data.NAME + " " + response.data.SURNAME;
          this.$store.state.USER_NAME = response.data.USER_NAME;

          this.Loading = false;
        }
        else {
          this.Loading = false;
          localStorage.removeItem("Token");
          localStorage.removeItem("AuthorizeToken");
          window.open(process.env.VUE_APP_URL_ADFS + "AgencyERequestConvertor", '_self');
        }
      }).catch((error) => {
        this.Loading = false;

        Swal.fire({
          icon: 'error',
          html: '<label class="fs-4 fw-normal font-family">ท่านไม่สามารถเข้าสู่ระบบได้</label>',
          confirmButtonText: 'ตกลง',
          allowOutsideClick: false,// ไม่ให้คลิกนอก popup เพื่อปิด
          allowEscapeKey: false,// ไม่ให้กด Esc เพื่อปิด
        }).then((result) => {
          if (result.isConfirmed) {
            localStorage.removeItem("Token");
            localStorage.removeItem("AuthorizeToken");
            window.open(process.env.VUE_APP_URL_ADFS + "AgencyERequestConvertor/Logout", '_self');
          }
        });

      });
    }
  },
};
</script>

<style scoped>
.font-family-bla {
  font-family: "DB Heavent";
  font-size: 1.3rem;
}

.headmoblie {
  background-color: #ffffff;
  -webkit-box-shadow: none;
  box-shadow: none;
  left: 0;
  padding: 1rem 0;
  /* position: fixed; */
  z-index: 200;
  right: 0;
  top: 0;
  -webkit-transition: -webkit-box-shadow 0.3s ease;
  transition: -webkit-box-shadow 0.3s ease;
  transition: box-shadow 0.3s ease;
  transition: box-shadow 0.3s ease, -webkit-box-shadow 0.3s ease;
}
</style>